import { useMutation } from '@apollo/client';
import { gql } from '__generated__';
import { FC } from 'react';
import { useNavigate } from 'react-router';

import ConfirmButton from 'components/ConfirmButton';

const GENERATE_IDENTITY_CARDS_MUTATION = gql(`
  mutation GenerateIdentityCards($departmentId: ID!) {
    generateIdentityCardsForDepartment(departmentId: $departmentId)
  }
`);

const GenerateIdentityCardsForDepartment: FC<{ departmentId: string }> = ({ departmentId }) => {
  const navigate = useNavigate();

  const [generateIdentityCards, { loading, error }] = useMutation(
    GENERATE_IDENTITY_CARDS_MUTATION,
    {
      variables: { departmentId },
      refetchQueries: ['DepartmentIdentityCards'],
      onCompleted() {
        navigate(`/departments/${departmentId}/identity-cards`);
      },
    }
  );

  return (
    <ConfirmButton
      title="Generate Identity Cards"
      description="Are you sure you want to generate identity cards for all active users in this department?"
      loading={loading}
      error={error}
      onConfirm={generateIdentityCards}
    >
      Generate Identity Cards For All Active Users
    </ConfirmButton>
  );
};

export default GenerateIdentityCardsForDepartment;
